document.addEventListener('DOMContentLoaded', () => {
  const BREAKPOINT = 992;
  const locations = document.querySelector('.js-our-locations');
  const btn = document.querySelector('.js-see-all-locations');
  if (!locations || !btn) return;

  const originalItems = Array.from(locations.children).filter((el) => el.nodeType === 1);

  let splideInstance = null;
  let desktopInited = false;
  let desktopClickHandler = null;
  let transitionHandler = null;

  function initDesktop() {
    if (desktopInited) return;
    desktopInited = true;

    locations.style.removeProperty('height');
    locations.style.removeProperty('transition');
    locations.style.flexWrap = 'nowrap';
    btn.classList.remove('d-none');

    desktopClickHandler = (e) => {
      e.preventDefault();

      const startHeight = locations.offsetHeight;

      locations.style.transition = 'height 0.4s ease';

      locations.style.flexWrap = 'wrap';
      locations.style.height = 'auto';
      const endHeight = locations.offsetHeight;

      locations.style.height = startHeight + 'px';
      requestAnimationFrame(() => {
        locations.style.height = endHeight + 'px';
      });

      transitionHandler = function handler() {
        locations.style.height = 'auto';
        locations.removeEventListener('transitionend', handler);
      };
      locations.addEventListener('transitionend', transitionHandler);

      btn.classList.add('d-none');
    };

    btn.addEventListener('click', desktopClickHandler);
  }

  function destroyDesktop() {
    if (!desktopInited) return;
    desktopInited = false;

    if (desktopClickHandler) {
      btn.removeEventListener('click', desktopClickHandler);
      desktopClickHandler = null;
    }
    if (transitionHandler) {
      locations.removeEventListener('transitionend', transitionHandler);
      transitionHandler = null;
    }
    locations.style.removeProperty('height');
    locations.style.removeProperty('transition');
  }

  function buildSplideStructure() {
    const splide = document.createElement('div');
    splide.className = 'splide js-locations-splide';

    const track = document.createElement('div');
    track.className = 'splide__track';

    const list = document.createElement('ul');
    list.className = 'splide__list';

    originalItems.forEach((item) => {
      const li = document.createElement('li');
      li.className = 'splide__slide';
      li.appendChild(item); 
      list.appendChild(li);
    });

    track.appendChild(list);
    splide.appendChild(track);

    locations.innerHTML = '';
    locations.appendChild(splide);

    locations.classList.add('with-slider');

    return splide;
  }

  function initMobile() {
    if (splideInstance) return;

    btn.classList.add('d-none');

    const splideRoot = buildSplideStructure();

    if (typeof Splide !== 'function') {
      return;
    }

    splideInstance = new Splide(splideRoot, {
      type: 'slide',
      perPage: 2,
      gap: '12px',
      rewind: true,
      pagination: true,
      arrows: true,
      arrowPath: "M12.744 18.9481C12.5878 19.1044 12.5 19.3163 12.5 19.5373C12.5 19.7582 12.5878 19.9702 12.744 20.1264L17.4582 24.8406C17.6153 24.9924 17.8258 25.0764 18.0443 25.0745C18.2628 25.0726 18.4718 24.9849 18.6263 24.8304C18.7808 24.6759 18.8685 24.4669 18.8704 24.2484C18.8723 24.0299 18.7883 23.8194 18.6365 23.6623L15.3448 20.3706H26.3807C26.6017 20.3706 26.8136 20.2828 26.9699 20.1265C27.1262 19.9702 27.214 19.7583 27.214 19.5373C27.214 19.3162 27.1262 19.1043 26.9699 18.948C26.8136 18.7917 26.6017 18.7039 26.3807 18.7039H15.3448L18.6365 15.4123C18.7883 15.2551 18.8723 15.0446 18.8704 14.8261C18.8685 14.6076 18.7808 14.3986 18.6263 14.2441C18.4718 14.0896 18.2628 14.0019 18.0443 14.0001C17.8258 13.9981 17.6153 14.0821 17.4582 14.2339L12.744 18.9481Z",
      breakpoints: {
        576: { perPage: 1 }
      }
    });

    splideInstance.mount();
  }

  function destroyMobile() {
    if (!splideInstance) return;

    const slides = locations.querySelectorAll('.splide__slide');
    locations.innerHTML = '';
    slides.forEach((slide) => {
      const child = slide.firstElementChild;
      if (child) locations.appendChild(child);
    });

    splideInstance.destroy(true);
    splideInstance = null;

    btn.classList.remove('d-none');
  }

  function applyMode() {
    if (window.innerWidth >= BREAKPOINT) {
      destroyMobile();
      initDesktop();
    } else {
      destroyDesktop();
      initMobile();
    }
  }

  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyMode, 150);
  });

  applyMode();
});